import { render, staticRenderFns } from "./modal-tell-friends.vue?vue&type=template&id=3d3af018"
import script from "./modal-tell-friends.vue?vue&type=script&lang=js"
export * from "./modal-tell-friends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports